/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BillingFrequencyEnum = 'PREPAID' | 'MONTHLY' | 'ANNUAL';

export const BillingFrequencyEnum = {

    PREPAID: 'PREPAID' as BillingFrequencyEnum,

    MONTHLY: 'MONTHLY' as BillingFrequencyEnum,

    ANNUAL: 'ANNUAL' as BillingFrequencyEnum
};

